export const environment = {
  production: false,
  apiUrl: 'https://sigecomapi-qa.mms.inf.br/api',
  useSintegra: false,
  devBeta: false,
  versionNumber: '2.1.53',
  versionTag: 'HML',
  enableMarquee: true,
  downloadQrCodeUrl:
    'https://sigecom-erp-qa.mms.inf.br/resources/cbde_qr_code_reader.zip',
};

/*

  Versionamento (X.Y.Z):

  X (MAJOR): Aumenta a cada deploy em produção (reinicia Y.Z)

  Y (FEATURE/MÓDULO): Aumenta a cada nova funcionalidade/tela (reinicia Z)

  Z (FIX): Aumenta a cada correção (hotfix/bug)

*/
